export default __webpack_public_path__ + "static/media/participantaddicon.d77db5a0.svg";